<template>
  <div>
    <el-input-number v-model="inputValue"></el-input-number>
    <span class="unit">{{ unit }}</span>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: {
    unit: {
      type: String,
      default: ''
    },
    editVal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      inputValue: this.editVal
    }
  },
  methods: {
    getCount() {
      return this.inputValue
    }
  }
}
</script>

<style scoped lang="scss">
.unit {
  font-size: var(--base-font-size-common);
  color: var(--base-color-text-primary);
  margin-left: var(--base-size-4);
}
</style>
